import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { EVENT_INFO, EVENT_CHECK_IN_PAGE, EVENT_PREVIEW } from "../Router/path";
import ImageSlider from "./ImageSlider";
import Popup from "./Popup";
import axios from "axios";
import { GET_EVENT_INFO_API } from "../Constant/api";
import { useToast } from "../Components/Toast";

const EventListCards = ({ id, imageSource, title, date, onClick }) => {
  const { toast } = useToast();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSelection = (event_id, selection) => {
    if (event_id) {
      setLoading(true);
      axios
        .get(GET_EVENT_INFO_API, {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("bearer_token")}`,
          },
          params: { eventId: event_id },
        })
        .then((response) => {
          const data = response.data.data;
          if (response.data.success) {
            sessionStorage.setItem("event_id", event_id);
            sessionStorage.setItem(
              "dietary",
              data.event_info.dietary_management
            );
            sessionStorage.setItem("seat", data.event_info.seat_management);
            switch (selection) {
              case "edit":
                navigate(EVENT_INFO);
                break;
              case "preview":
                navigate(EVENT_PREVIEW, {
                  state: {
                    eventInfo: data.event_info,
                    customizations: data.customizations,
                    monetary: data.monetary,
                  },
                });
                break;
              case "event_page":
                navigate(EVENT_CHECK_IN_PAGE);
                break;
              default:
                break;
            }
          } else {
            toast(response.data.message, "error");
          }
          setLoading(false);
        })
        .catch((error) => {
          setLoading(false);
          console.log(error);
          toast("Failed to fetch event info", "error");
        });
    }
  };

  return (
    <div
      className={`flex flex-col min-w-[278px] max-h-fit p-[16px] gap-[16px] border border-[#EFF0F2] rounded-md hover:bg-[#F7F8F9] hover:cursor-pointer ${
        loading && "opacity-50 pointer-events-none"
      }`}
      onClick={() => {
        if (!loading) onClick(id);
      }}
    >
      <div className="aspect-[3/2] max-w-[246px] max-h-[164px] flex w-full rounded-md justify-center">
        <ImageSlider imageList={imageSource} rounded />
      </div>
      <div className="flex flex-row justify-between">
        <div className="flex flex-col w-full">
          <h1 className="font-md text-[14px]">{title}</h1>
          <p className="font-md text-[11px] text-[#636C7E]">
            {date ?? "No date"}
          </p>
        </div>
        {sessionStorage.getItem("has_event_id") === "false" && (
          <div onClick={(e) => e.stopPropagation()}>
            <Popup
              onEdit={() => handleSelection(id, "edit")}
              onPreview={() => handleSelection(id, "preview")}
              onEventPage={() => handleSelection(id, "event_page")}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default EventListCards;
